export class LoanProduct {
    percentageInterestRate: number;
    minimumNumberOfMonths: number;
    maximumNumberOfMonths: number;
    percentageIncreaseMonthStep: number;
    percentageIncrease: number;
    storeCostPrice: number;
    hotDeal: boolean;

    constructor({
        percentageInterestRate,
        minimumNumberOfMonths,
        maximumNumberOfMonths,
        percentageIncreaseMonthStep,
        percentageIncrease,
        storeCostPrice,
        hotDeal
    } : LoanProduct) {
        this.percentageInterestRate = percentageInterestRate;
        this.minimumNumberOfMonths = minimumNumberOfMonths;
        this.maximumNumberOfMonths = maximumNumberOfMonths;
        this.percentageIncreaseMonthStep = percentageIncreaseMonthStep;
        this.percentageIncrease = percentageIncrease;
        this.storeCostPrice = storeCostPrice;
        this.hotDeal = hotDeal;
    }
}